module.exports = __webpack_public_path__ + "images/pages/for_business/pc/img03_18d7b95b219eab43022f8d4a5fab46f5.png";